import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute - Guards routes that require authentication.
 * Shows a loading spinner while auth state is being resolved.
 * Redirects unauthenticated users to the login page.
 *
 * @param {React.ReactNode} children - The protected content to render.
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  /* Show loading spinner while authentication state is being determined. */
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
      </div>
    );
  }

  /* Redirect to login if user is not authenticated. */
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
